import {
  SET_GENERAL_SETTING,
  SET_LOADING_STATE,
  UPDATE_BATCH_FILE,
  UPDATE_CATEGORIES,
  UPDATE_DEFAULT_CONTACT_LIST,
  UPDATE_DELIVERY_SETTING,
  UPDATE_FINANCIAL_CONTACT,
  UPDATE_LABELS,
  UPDATE_LEGAL_ENTITIES,
  UPDATE_NDIS_CATALOGUE,
  UPDATE_NOTIFICATION_STATS,
  UPDATE_NOTIFICATIONS,
  UPDATE_ORG_ID,
  UPDATE_PARTICIPANTS_LOOKUP,
  UPDATE_PRODUCT,
  UPDATE_REGO_LIST,
  UPDATE_REMITTANCE,
  UPDATE_SAH_PROVIDER_LIST,
  UPDATE_SAH_SERVICE_CATALOGUE,
  UPDATE_SAH_SERVICE_CATALOGUE_PRICING,
  UPDATE_SAH_SERVICE_PROVIDERS,
  UPDATE_SUCCESSFUL_CLAIMS,
  UPDATE_USER_INFO,
} from '../actions/action-types';

interface IInitialAppState {
  user: Object;
  regos: Array<Object>;
  financialContact: Array<Object>;
  legalEntities: Array<Object>;
  ndis_catalogue: Array<Object>;
  batch_file_list: Array<Object>;
  orgDefaultContactList: Array<Object>;
  successful_claims: any;
  remittance: any;
  notifications: any;
  categories: any;
  labels: any;
  orgId: string;
  sahProviders: Array<Object>;
  sahServiceProviders: Array<Object>;
  sahServiceCataloguePricing: Array<Object>;
  sahServiceCatalogue: Array<Object>;
  participantsLookup: Array<Object>;
  deliverySetting: {
    importPersistErrorsKey: string | null;
  };
  generalSettings: Record<string, string>;
  loadingStates: {
    userInfo: boolean;
    notificationStats: boolean;
    rego: boolean;
    categoryX: boolean;
    categoryY: boolean;
    financialContact: boolean;
    product: boolean;
    ndisCatalogue: boolean;
    legalEntities: boolean;
  };
}

const initialState: IInitialAppState = {
  user: {},
  regos: [],
  sahProviders: [],
  sahServiceProviders: [],
  sahServiceCataloguePricing: [],
  sahServiceCatalogue: [],
  ndis_catalogue: [],
  participantsLookup: [],
  financialContact: [],
  legalEntities: [],
  successful_claims: {},
  batch_file_list: [],
  orgDefaultContactList: [],
  remittance: {},
  notifications: {},
  categories: {},
  deliverySetting: {
    importPersistErrorsKey: null,
  },
  generalSettings: {},
  labels: {
    categoryXDL: 'Category X',
    categoryYDL: 'Category Y',
    categoryAttribute1DL: 'Attribute 1',
    categoryAttribute2DL: 'Attribute 2',
    categoryAttribute3DL: 'Attribute 3',
    categoryAttribute4DL: 'Attribute 4',
    categoryAttribute5DL: 'Attribute 5',
    userField1DL: 'User Field 1',
    userField2DL: 'User Field 2',
    userField3DL: 'User Field 3',
    userField4DL: 'User Field 4',
    userField5DL: 'User Field 5',
    userField6DL: 'User Field 6',
    userField7DL: 'User Field 7',
    userField8DL: 'User Field 8',
    userField9DL: 'User Field 9',
    userField10DL: 'User Field 10',
    participantUserField1DL: 'User Field 1',
    participantUserField2DL: 'User Field 2',
    participantUserField3DL: 'User Field 3',
    participantUserField4DL: 'User Field 4',
    participantUserField5DL: 'User Field 5',
    participantUserField6DL: 'User Field 6',
    participantUserField7DL: 'User Field 7',
    participantUserField8DL: 'User Field 8',
    participantUserField9DL: 'User Field 9',
    participantUserField10DL: 'User Field 10',
    contactUserField1DL: 'User Field 1',
    contactUserField2DL: 'User Field 2',
    contactUserField3DL: 'User Field 3',
    contactUserField4DL: 'User Field 4',
    contactUserField5DL: 'User Field 5',
    contactUserField6DL: 'User Field 6',
    contactUserField7DL: 'User Field 7',
    contactUserField8DL: 'User Field 8',
    contactUserField9DL: 'User Field 9',
    contactUserField10DL: 'User Field 10',
    sahUserField1DL: 'User Field 1',
    sahUserField2DL: 'User Field 2',
    sahUserField3DL: 'User Field 3',
    sahUserField4DL: 'User Field 4',
    sahUserField5DL: 'User Field 5',
    sahUserField6DL: 'User Field 6',
    sahUserField7DL: 'User Field 7',
    sahUserField8DL: 'User Field 8',
    sahUserField9DL: 'User Field 9',
    sahUserField10DL: 'User Field 10',
    sahCareRecipientUserField1DL: 'User Field 1',
    sahCareRecipientUserField2DL: 'User Field 2',
    sahCareRecipientUserField3DL: 'User Field 3',
    sahCareRecipientUserField4DL: 'User Field 4',
    sahCareRecipientUserField5DL: 'User Field 5',
    sahCareRecipientUserField6DL: 'User Field 6',
    sahCareRecipientUserField7DL: 'User Field 7',
    sahCareRecipientUserField8DL: 'User Field 8',
    sahCareRecipientUserField9DL: 'User Field 9',
    sahCareRecipientUserField10DL: 'User Field 10',
    invoiceDimension1DL: 'Dimension 1',
    invoiceDimension2DL: 'Dimension 2',
    invoiceDimension3DL: 'Dimension 3',
    invoiceDimension4DL: 'Dimension 4',
    invoiceDimension5DL: 'Dimension 5',
    invoiceDimension6DL: 'Dimension 6',
    invoiceDimension7DL: 'Dimension 7',
    invoiceDimension8DL: 'Dimension 8',
    invoiceDimension9DL: 'Dimension 9',
    invoiceDimension10DL: 'Dimension 10',
  },
  orgId: '',
  loadingStates: {
    userInfo: true,
    notificationStats: false,
    rego: false,
    categoryX: false,
    categoryY: false,
    financialContact: false,
    product: false,
    ndisCatalogue: false,
    legalEntities: false,
  },
};

// eslint-disable-next-line default-param-last
const appReducer = (state = initialState, action: { type: any; payload: any }) => {
  switch (action.type) {
    case UPDATE_USER_INFO:
      return {
        ...state,
        user: {
          ...action.payload,
        },
        loadingStates: {
          ...state.loadingStates,
          userInfo: false,
        },
      };

    case UPDATE_ORG_ID:
      return {
        ...state,
        orgId: action.payload,
        // Clear org-specific cached data that should not leak across orgs
        participantsLookup: [],
        generalSettings: {},
      };

    case UPDATE_REGO_LIST:
      return {
        ...state,
        regos: action.payload,
      };

    case UPDATE_NDIS_CATALOGUE:
      return {
        ...state,
        ndis_catalogue: action.payload,
      };

    case UPDATE_SUCCESSFUL_CLAIMS:
      return {
        ...state,
        successful_claims: {
          data: {
            ...state.successful_claims.data,
            ...action.payload.data,
          },
          pagination: action.payload.pagination,
        },
      };

    case UPDATE_REMITTANCE:
      return {
        ...state,
        remittance: {
          data: {
            ...state.remittance.data,
            ...action.payload.data,
          },
          pagination: action.payload.pagination,
        },
      };

    case UPDATE_BATCH_FILE:
      return {
        ...state,
        batch_file_list: action.payload,
      };

    case UPDATE_FINANCIAL_CONTACT:
      return {
        ...state,
        financialContact: action.payload,
      };

    case SET_GENERAL_SETTING: {
      const { orgId, settingKey, settingValue } = action.payload;
      const cacheKey = `${orgId}:${settingKey}`;
      return {
        ...state,
        generalSettings: {
          ...state.generalSettings,
          [cacheKey]: settingValue,
        },
      };
    }

    case UPDATE_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case UPDATE_NOTIFICATION_STATS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          ...action.payload,
        },
      };
    case UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          ...action.payload,
        },
      };

    case UPDATE_CATEGORIES:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.payload.type]: action.payload.data,
        },
      };

    case UPDATE_DEFAULT_CONTACT_LIST:
      return {
        ...state,
        orgDefaultContactList: action.payload,
      };

    case SET_LOADING_STATE:
      return {
        ...state,
        loadingStates: {
          ...state.loadingStates,
          [action.payload.key]: action.payload.value,
        },
      };

    case UPDATE_SAH_PROVIDER_LIST:
      return {
        ...state,
        sahProviders: action.payload,
      };

    case UPDATE_SAH_SERVICE_PROVIDERS:
      return {
        ...state,
        sahServiceProviders: action.payload,
      };

    case UPDATE_SAH_SERVICE_CATALOGUE_PRICING:
      return {
        ...state,
        sahServiceCataloguePricing: action.payload,
      };

    case UPDATE_SAH_SERVICE_CATALOGUE:
      return {
        ...state,
        sahServiceCatalogue: action.payload,
      };

    case UPDATE_LABELS:
      return {
        ...state,
        labels: {
          ...initialState.labels,
          ...action.payload,
        },
      };

    case UPDATE_PARTICIPANTS_LOOKUP:
      return {
        ...state,
        participantsLookup: action.payload,
      };

    case UPDATE_LEGAL_ENTITIES:
      return {
        ...state,
        legalEntities: action.payload,
      };

    case UPDATE_DELIVERY_SETTING:
      return {
        ...state,
        deliverySetting: {
          ...state.deliverySetting,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
export default appReducer;
